import { getWidthOfSlotByRange } from './generators'
import { calculatePercentagePositionInARow } from '../helpers'
import { IAdmissionRowSlots, IAdmissionStructured, TimelinePeriodTypes } from '~/interfaces/timeline'

interface ICreateAdmissionStructure {
  admissions: IAdmissionRowSlots[]
  mode: TimelinePeriodTypes
}

export const createAdmissionsStructure = ({ admissions, mode }: ICreateAdmissionStructure): IAdmissionStructured[] => {
  const structuredAdmissions = admissions.map(admission => {
    const width = getWidthOfSlotByRange(admission.startDate, admission.endDate)(mode)
    const percentagePosition = calculatePercentagePositionInARow(admission.startDate, mode)

    return {
      ...admission,
      percentagePosition: percentagePosition,
      width
    }
  })

  return structuredAdmissions
}
